export default __webpack_public_path__ + "assets/front/scss/classification-browsing.91aaadbda580610d6453249a55a4b9f5.css";